import React, { Fragment, useContext } from "react";
import { getMode } from "../../../utils/getMode";
import {
  Box,
  Container,
  Paper,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { calculateHeaderHeights } from "../../../utils/calculateHeaderHeights";
import Text from "./Text";
import LogoContainer from "./LogoContainer";

const SectionElement = ({
  completed = false,
  currentSection = false,
  title,
  fillBar = "0%",
}) => {
  const { palette, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const color =
    currentSection || completed ? palette.secondary.main : "inherit";

  return (
    <Box
      display="flex"
      width={title ? "100%" : "inherit"}
      alignItems="center"
      justifyContent="flex-end"
      color={color}
    >
      {title && (
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          whiteSpace={"nowrap"}
        >
          <Typography
            style={{
              fontSize: isScreenXs ? "10px" : "12px",
            }}
            color={currentSection ? "textPrimary" : "textSecondary"}
          >
            {title}
          </Typography>
          <Box bgcolor={palette.grey[300]} height="2px" width="90%">
            <Box
              bgcolor={color}
              height="2px"
              width={fillBar}
              style={{
                transition: "all 0.5s ease",
                opacity: completed ? 0.6 : 1,
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

const SectionSummary = () => {
  const { palette } = useTheme();
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const {
    state: {
      sectionsArray,
      currentSection,
      currentSectionProgress,
      appStarted,
      hideSections,
    },
  } = useContext(ProcessContext);

  const sectionsHeight = calculateHeaderHeights.getSectionsHeight(
    isScreenXs,
    currentSection,
    sectionsArray,
    appStarted && !hideSections
  );

  const mode = getMode();

  const embedded = mode === "embedded";

  return (
    <Container
      maxWidth="sm"
      className="transition-all"
      style={{ height: sectionsHeight, overflow: "hidden" }}
    >
      <>
        {currentSection && sectionsArray && !embedded && (
          <Box
            mt={0}
            className="transition-all"
            bgcolor="transparent"
            borderRadius="500px"
            display={"flex"}
            p={1}
            color={palette.grey[500]}
          >
            {sectionsArray.map((sectionItem, sectionIndex) => {
              if (!currentSection || !sectionItem) return null;
              const isCurrentSection =
                sectionItem.nameTextId === currentSection.nameTextId;
              const currentSectionIndexInArray = sectionsArray.findIndex(
                (section) =>
                  section && section.nameTextId === currentSection.nameTextId
              );
              const completed = currentSectionIndexInArray > sectionIndex;
              const notCurrentSectionProgress = completed ? "100%" : "0%";
              return (
                <SectionElement
                  key={sectionIndex}
                  completed={completed}
                  currentSection={isCurrentSection}
                  fillBar={
                    isCurrentSection
                      ? currentSectionProgress
                      : notCurrentSectionProgress
                  }
                  title={<Text tId={sectionItem.nameTextId} />}
                />
              );
            })}
          </Box>
        )}
      </>
    </Container>
  );
};

export default function AppHeader() {
  const {
    state: { appStarted },
  } = useContext(ProcessContext);

  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));
  return (
    <Fragment>
      <Container
        className={"transition-all"}
        maxWidth={"sm"}
        style={{ padding: 0 }}
      >
        <Paper
          square
          elevation={0}
          style={{
            boxShadow: isScreenXs ? null : "0px 0px 30px -10px #4242",
            // borderTopLeftRadius: customBorderRadius.paper,
            // borderTopRightRadius: customBorderRadius.paper,
          }}
        >
          <LogoContainer appStarted={appStarted} />
          <SectionSummary />
        </Paper>
      </Container>
    </Fragment>
  );
}
